import { getDimensionFor, getLeftOrTop } from "./direction-helpers"

import { nullifyTransforms } from "./helpers"

const moveToIndexFor = (flexyInstance, cb) => {
  let fromIndex = [...flexyInstance.sliderContainer.children].indexOf(
    [...flexyInstance.sliderContainer.children].reduce(
      (leftmostEl, currentEl) => {
        let left = getLeftOrTop(
          nullifyTransforms(
            leftmostEl,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )

        let currentLeft = getLeftOrTop(
          nullifyTransforms(
            currentEl,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )

        return Math.abs(
          currentLeft -
            getLeftOrTop(
              nullifyTransforms(
                flexyInstance.sliderContainer,
                flexyInstance.options.nullifyTransformEl
              ),
              flexyInstance
            )
        ) <
          Math.abs(
            left -
              getLeftOrTop(
                nullifyTransforms(
                  flexyInstance.sliderContainer,
                  flexyInstance.options.nullifyTransformEl
                ),
                flexyInstance
              )
          )
          ? currentEl
          : leftmostEl
      },
      {
        getBoundingClientRect: () => ({
          left: 100000000000,
          top: 100000000000,
        }),
      }
    )
  )

  let toIndex = cb(fromIndex)

  if (toIndex < 0) {
    toIndex = flexyInstance.sliderContainer.children.length - 1
  }

  if (toIndex > flexyInstance.sliderContainer.children.length - 1) {
    toIndex = 0
  }

  let amountToTheLeft = Math.abs(toIndex - fromIndex)
  let amountToTheRight =
    Math.min(fromIndex, toIndex) +
    (flexyInstance.sliderContainer.children.length -
      Math.max(fromIndex, toIndex))

  let p =
    Math.min(amountToTheLeft, amountToTheRight) *
    (amountToTheRight > amountToTheLeft
      ? fromIndex > toIndex
        ? 1
        : -1
      : fromIndex > toIndex
      ? -1
      : 1)

  let resultTarget =
    (Math.round(
      (flexyInstance.state.positionX * 100) /
        getDimensionFor(
          nullifyTransforms(
            flexyInstance.sliderContainer.firstElementChild,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        ) /
        100
    ) *
      100 *
      getDimensionFor(
        nullifyTransforms(
          flexyInstance.sliderContainer.firstElementChild,
          flexyInstance.options.nullifyTransformEl
        ),
        flexyInstance
      )) /
      100 +
    getDimensionFor(
      nullifyTransforms(
        flexyInstance.sliderContainer.firstElementChild,
        flexyInstance.options.nullifyTransformEl
      ),
      flexyInstance
    ) *
      p

  flexyInstance.state = {
    ...flexyInstance.state,
    positionTarget: resultTarget,
  }
}

export const mountArrowsListeners = (flexyInstance) => {
  flexyInstance.options.leftArrow &&
    flexyInstance.options.leftArrow.addEventListener("click", (e) => {
      e.preventDefault()
      moveToIndexFor(flexyInstance, (fromIndex) => fromIndex - 1)
    })

  flexyInstance.options.rightArrow &&
    flexyInstance.options.rightArrow.addEventListener("click", (e) => {
      e.preventDefault()
      moveToIndexFor(flexyInstance, (fromIndex) => fromIndex + 1)
    })
}
